/**
 * Sets a cookie to remember the user's locale preference
 * This prevents automatic redirection based on browser locale
 */
export const setLocaleCookie = (locale: string): void => {
  if (typeof document === 'undefined') return;
  const maxAge = 60 * 60 * 24 * 365;
  document.cookie = `NEXT_LOCALE=${locale};path=/;max-age=${maxAge};SameSite=Lax`;
};
